import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Nav,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
  TabContent,
  TabPane,
  Input,
  InputGroup,
} from "reactstrap";
import { Btn, P } from "../../../../../AbstractElements";

import BaseModal from "../../../../../Shared/Components/Modal/BaseModal";
import NoteContext from "../../../../Notes/Context/Index";
import Scrollbars from "react-custom-scrollbars-2";
import NoteForm from "../../../../Notes/Presentation/NoteForm";
import HistoryFilters from "./HistoryFilters";
import CardNote from "../../../../Notes/Presentation/CardNote";
import EmptyState from "../../../../../Shared/Components/EmptyState";
import FilesProvider from "../../../../Files/Context/FilesProvider";
import LinksProvider from "../../../../Links/Context/LinksProvider";
import NoteModalHeader from "../../../../Notes/Presentation/NoteModalHeader";
import { getUsersApi } from "../../../../../Shared/Api/getUsers";

export default function HistorialData({ contact_id }) {
  const {
    items,
    fetchItems,
    currentPage,
    rowsPerPage,
    setCurrentPage,
    modalTogle,
    showModal,
    setShowModal,
    filters,
    setFilters,
    setItems,
    setItem,
    totalRows,
    setReadOnly,
    setIsAdding,
    firstId,
    lastId,

    fetchFirstId,
    fetchLastId,
  } = useContext(NoteContext);
  const [selectedTypes, setSelectedTypes] = useState(["Notas"]);
  const [PrimarycolorLineTab, setPrimarycolorLineTab] = useState("1");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [booleanFilters, setBooleanFilters] = useState([]);

  const [users, setUsers] = useState([]);

  const [usersSelected, setUsersSelected] = useState([]);
  const handleClearFilters = () => {
    setDateFrom("");
    setDateTo("");
    handleTypeSelect("Todos");
    setBooleanFilters([]);
    setUsersSelected([]);
  };

  const handleBooleanFiltersButtonSelect = (type) => {
    console.log(type);

    setBooleanFilters(type);
  };

  const handleNewNote = () => {
    setReadOnly(false);
    setItem({});
    setIsAdding(true);
    setShowModal(true);
  };

  const handleApplyFilters = () => {
    let filterType = [];

    booleanFilters.forEach((t) => {
      if (t === "Con archivos") {
        filterType.push("with_files");
      } else if (t === "Con enlaces") {
        filterType.push("with_links");
      } else {
        filterType.push(t);
      }
    });

    const newFilters = {
      ...filters,
      types: selectedTypes,
      date_from: dateFrom,
      date_to: dateTo,
      search: searchTerm,
      users: usersSelected.map((user) => user.id),
    };

    if (!filterType.includes("with_files")) {
      delete newFilters.with_files;
    } else {
      newFilters.with_files = true;
    }
    if (!filterType.includes("with_links")) {
      delete newFilters.with_links;
    } else {
      newFilters.with_links = true;
    }
    setFilters(newFilters);
  };

  useEffect(() => {
    if (contact_id != undefined) {
      setFilters({
        ...filters,
        ...{ model_id: contact_id },
      });
    }
  }, [contact_id]);

  useEffect(() => {
    setCurrentPage(1);
    setItems([]);
    if (filters.model_id != undefined) {
      fetchItems(currentPage, rowsPerPage);
      fetchFirstId(contact_id);
      fetchLastId(contact_id);
    }
  }, [filters]);

  useEffect(() => {
    if (filters.model_id != undefined) {
      fetchItems(currentPage, rowsPerPage);
    }
  }, [currentPage]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e?.target;
    if (totalRows % rowsPerPage !== 0) return;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      // Se resta 10 para tolerancia
      setCurrentPage(currentPage + 1);
    }
  };

  const handleTypeSelect = (type) => {
    setSelectedTypes([type]);
  };

  const handleSearch = () => {
    handleApplyFilters();
  };

  //todo aplicar paginacion
  const fetchUsers = async () => {
    let response = await getUsersApi();
    if (response.result === "success") {
      const formattedUsers = response.data?.items.map((user) => ({
        ...user,
        name: `${user.first_name} ${user.last_name}`, //todo el backen  deberia devolver name
      }));
      setUsers(formattedUsers);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleUsersChange = (selectedUsers) => {
    setUsersSelected(selectedUsers);
  };

  return (
    <>
      <BaseModal
        show={showModal}
        modalTogle={modalTogle}
        title="Nota"
        size={"lg"}
        modalHeader={
          <NoteModalHeader title="Nota" firstId={firstId} lastId={lastId} />
        }
      >
        <FilesProvider>
          <LinksProvider>
            <NoteForm
              modalTogle={modalTogle}
              contact_id={contact_id}
            ></NoteForm>
          </LinksProvider>
        </FilesProvider>
      </BaseModal>

      <Card className="p-4">
        <div className="media-body flex-grow-2 mt-0 ">
          <Nav className="border-tab nav-primary p-4" tabs>
            <NavItem>
              <NavLink
                href="#javascript"
                className={PrimarycolorLineTab === "1" ? "active" : ""}
                onClick={() => setPrimarycolorLineTab("1")}
              >
                <i className="icofont icofont-growth"></i>
                Historial
              </NavLink>
            </NavItem>
            <NavItem>
              <Button
                id="PopoverFiltro"
                className={`btn-no-bg ${popoverOpen ? "active" : ""}`}
                onClick={() => setPopoverOpen(!popoverOpen)}
              >
                <i className="icofont icofont-filter"></i> Filtros
              </Button>
              <Popover
                trigger="legacy"
                placement="bottom"
                isOpen={popoverOpen}
                target="PopoverFiltro"
                toggle={() => setPopoverOpen(!popoverOpen)}
                innerClassName="rounded-4 shadow"
              >
                <PopoverBody
                  className="rounded-4 p-2 border border-2 w-100 "
                  style={{
                    borderColor: "#d3d3d3",
                  }}
                >
                  <HistoryFilters
                    handleClearFilters={handleClearFilters}
                    booleanFilters={booleanFilters}
                    handleBooleanFiltersButtonSelect={
                      handleBooleanFiltersButtonSelect
                    }
                    setFilters={setFilters}
                    filters={filters}
                    setPopoverOpen={setPopoverOpen}
                    handleTypeSelect={handleTypeSelect}
                    setDateFrom={setDateFrom}
                    setDateTo={setDateTo}
                    handleApplyFilters={handleApplyFilters}
                    selectedTypes={selectedTypes}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    handleUsersChange={handleUsersChange}
                    users={users}
                    usersSelected={usersSelected}
                  ></HistoryFilters>
                </PopoverBody>
              </Popover>
            </NavItem>
            <NavItem className="d-flex align-items-center">
              <InputGroup className="w-100 w-md-100 w-lg-100 w-xl-75 w-xxl-60 search-input-group">
                <div className="position-relative w-100">
                  <i
                    className="icofont icofont-navigation-menu position-absolute"
                    style={{
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#6c757d",
                      zIndex: 4,
                    }}
                  ></i>
                  <Input
                    type="text"
                    placeholder="Buscar en notas"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                    style={{
                      paddingLeft: "40px",
                      paddingRight: "40px",
                      backgroundColor: "#f8f9fa",
                      border: "1px solid #dee2e6",
                      borderRadius: "20px",
                    }}
                  />
                  <i
                    className="icofont icofont-search position-absolute"
                    style={{
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#6c757d",
                      cursor: "pointer",
                      zIndex: 4,
                    }}
                    onClick={handleSearch}
                  ></i>
                </div>
              </InputGroup>
            </NavItem>
          </Nav>

          <TabContent activeTab={PrimarycolorLineTab}>
            <TabPane className="fade show" tabId="1">
              <Col xl="12" md="12" className="d-flex justify-content-between">
                <div className="d-flex gap-3">
                  <P>{selectedTypes}</P>
                </div>
                <Btn
                  attrBtn={{
                    className: "mb-3",
                    color: "primary",
                    onClick: handleNewNote,
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    },
                  }}
                >
                  Nueva Nota
                  <i className="icofont icofont-plus"></i>
                </Btn>
              </Col>
              {items.length > 0 ? (
                <Col xl="12" md="12" className="d-flex justify-content-between">
                  <Scrollbars
                    autoHeight
                    autoHeightMin={1500}
                    autoHeightMax={1500}
                    onScroll={handleScroll}
                    className="click-drag-handler p-0 "
                    style={{ width: "100%" }}
                  >
                    {items.map(function (note, i) {
                      return (
                        <CardNote key={i} note={note} index={i}></CardNote>
                      );
                    })}
                  </Scrollbars>
                </Col>
              ) : (
                <EmptyState msg="No hay notas para mostrar"></EmptyState>
              )}
            </TabPane>
          </TabContent>
        </div>
      </Card>
    </>
  );
}
